<template>
  <UInput
    v-model="model"
    :size="size"
    :type="passwordHidden ? 'password' : 'text'"
    :placeholder="placeholder"
    :aria-label="placeholder"
    :ui="{ icon: { trailing: { pointer: '' } } }"
  >
    <template #trailing>
      <UButton
        color="black"
        variant="link"
        :icon="passwordHidden ? 'i-heroicons-eye' : 'i-heroicons-eye-slash'"
        :aria-label="t('a11y.show-password')"
        :padded="false"
        @click="passwordHidden = !passwordHidden"
      />
    </template>
  </UInput>
</template>
<script setup lang="ts">
import type { InputSize, ButtonColor, ButtonVariant } from '#ui/types'

const model = defineModel<string>()

interface propsInterface {
  placeholder?: string
  size?: InputSize
  buttonColor?: ButtonColor
  buttonVariant?: ButtonVariant
}
withDefaults(defineProps<propsInterface>(), {
  placeholder: '',
  size: 'lg',
  buttonColor: 'black',
  buttonVariant: 'link',
})
const passwordHidden = ref(true)
</script>
